[
     {
        "storeNumber": "2522",
        "country": "GBR",
        "disableStoreSwitching": true,
        "hideFromOtherStores": true
    }
]